﻿export const ADMIN_RESEND_CONFIRMATION = 'L\u2019ancien lien sera d\u00e9sactiv\u00e9 et un nouveau lien sera envoy\u00e9 au client.';
export const ADMIN_RESEND_SUCCESS = 'Nouveau lien envoy\u00e9.';
export const ADMIN_RESEND_ERROR = "Impossible de renvoyer l'ebook pour le moment.";

export function canShowAdminResendAction(status: string): boolean {
  return status === 'paid';
}

export function buildAdminResendEndpoint(orderId: string): string {
  return `/api/admin/orders/${encodeURIComponent(orderId)}/resend`;
}

export function formatAdminDownloadUsage(accesses?: Array<{ download_count: number; max_downloads: number | null; revoked_at: string | null }> | null): string {
  const activeAccess = accesses?.find((access) => !access.revoked_at) ?? accesses?.[0];
  if (!activeAccess) return '';
  if (activeAccess.max_downloads === null) return `${activeAccess.download_count} / Illimité`;
  return `${activeAccess.download_count} / ${activeAccess.max_downloads}`;
}
